module.exports = __webpack_public_path__ + "media/ai-thumbnail.f2b63d6a.mp4";